import { type ReactNode } from 'react';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Spinner from '@erikdakoda/ui/components/SpinnerOverlay';
import authConfig from '@erikdakoda/auth/shared/config';
import { useSessionGuardState } from '../hooks/useSessionGuardState';

interface GuestGuardProps {
  children: ReactNode | ReactNode[];
}

export default function GuestGuard({ children }: GuestGuardProps) {
  'use memo';

  const { session, isInitialSessionLoad } = useSessionGuardState();
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    if (session) {
      if (router.query.returnUrl) {
        router.replace(String(router.query.returnUrl));
      } else {
        router.replace(authConfig.config.pages.authHome);
      }
    }
  }, [router.route, session]);

  if (isInitialSessionLoad) {
    return <Spinner className="guest-guard" />;
  }

  return children;
}
